import { KnowledgeBaseSnippetKind } from 'types'
import { string } from 'yup'
import { safify } from '../utils/safify'

export const avoid = string()
  .default('')
  .meta({
    label: 'Avoid',
    placeholder: 'Add specific words, phrases or concepts to avoid',
    mobilePlaceholder: 'Add words or phrases to avoid',
    snippets: [KnowledgeBaseSnippetKind.AvoidList],
    autoFill: true,
  })
  .transform(safify)
